export default __webpack_public_path__ + "static/MediaContentSix-6b6afb4bdb1804ef9a803b9e3219276a.webp";